import { RETAILER_RISK_CONTROL_ACTIONS } from "constants";

export function fetchRetailerRiskControlDetail(caseId, company_id) {
    return {
        type: RETAILER_RISK_CONTROL_ACTIONS.FETCH_RETAILER_RISK_CONTROL_DETAIL,
        payload: {
            caseId,
            company_id
        }
    };
}
export function fetchedRetailerRiskControlDetail(caseId, dbRiskControlDetail) {
    return {
        type: RETAILER_RISK_CONTROL_ACTIONS.FETCHED_RETAILER_RISK_CONTROL_DETAIL,
        payload: {
            caseId,
            dbRiskControlDetail
        }
    };
}
export function failedFetchRetailerRiskControlDetail(caseId, error) {
    return {
        type: RETAILER_RISK_CONTROL_ACTIONS.FAILED_FETCH_RETAILER_RISK_CONTROL_DETAIL,
        payload: {
            caseId
        },
        error
    };
}

export function updateRetailerRiskControlDetail(caseId, retailerRiskControlDetail, method) {
    return {
        type: RETAILER_RISK_CONTROL_ACTIONS.UPDATE_RETAILER_RISK_CONTROL_DETAIL,
        payload: {
            caseId,
            retailerRiskControlDetail,
            method
        }

    };
}

export function updatedRetailerRiskControlDetail(caseId, retailerRiskControlDetail) {
    return {
        type: RETAILER_RISK_CONTROL_ACTIONS.UPDATED_RETAILER_RISK_CONTROL_DETAIL,
        payload: {
            caseId,
            retailerRiskControlDetail
        }
    };
}
export function failedUpdateRetailerRiskControlDetail(caseId, error) {
    return {
        type: RETAILER_RISK_CONTROL_ACTIONS.FAILED_UPDATE_RETAILER_RISK_CONTROL_DETAIL,
        payload: {
            caseId
        },
        error
    };
}
